import { InfoField } from '@occc/ui-design-system';
import { ConstraintFragment } from '@occc/graphql';
import { useMemo } from 'react';
import { getConstraintsByType } from '../constraints-section.utils';
import { formatDaysRange, formatTimeRange, formatTimeZones } from '../../formatters';

export const FulfillmentWindowConstraint = ({
  constraints,
}: {
  constraints: ConstraintFragment[];
}) => {
  const daysCst = getConstraintsByType('ConstraintDaysOfWeek', constraints);
  const timeCst = getConstraintsByType('ConstraintTimeOfDay', constraints);

  const days = formatDaysRange(daysCst.flatMap((c) => c.availableWeeklyOnDays ?? []));
  const time = formatTimeRange(
    timeCst.map((c) => [c.availableDailyStartingAtTime, c.availableDailyEndingAtTime]),
  );

  const zones = formatTimeZones([
    ...daysCst.map((c) => c.startOfDayTimezone),
    ...timeCst.map((c) => c.timezone),
  ]);

  const value = useMemo(() => {
    return [days, time, zones].filter(Boolean).join(' ');
  }, [days, time, zones]);

  return <InfoField label='Fulfillment Window' value={value} />;
};
